import SceneObject from "../../../lib/services/scene/sceneobject";
import ShaderService from "../../../lib/services/shader/shader_service";
import NavReticlePipeline from "../../../lib/services/render/pipelines/nav_reticle_renderpipeline";
import PlanePivotRenderPipeline from "../../../lib/services/render/pipelines/plane_pivot_renderpipeline";
import Camera from "../../../lib/services/scene/camera";
import ResourceService from "../../../lib/services/resource/resourceservice";

const GROUND_PIPELINE =0;
const NAV_PIPELINE = 1;

export default class Reticle extends SceneObject 
{
   ground_pipeline: PlanePivotRenderPipeline;
   nav_pipeline: NavReticlePipeline;
   ground_glow_pipeline: PlanePivotRenderPipeline;
   nav_glow_pipeline: NavReticlePipeline;

   current_pipeline: number;
   visible: boolean = false;
   private ready: boolean = false;
  
   constructor(key: string) 
  {
    super(key);
    this.ground_pipeline = new PlanePivotRenderPipeline("reticle_ground","unlit_texture_alpha","reticle_ground",1,1);
    this.nav_pipeline = new NavReticlePipeline("reticle_nav","unlit_texture_alpha","reticle",1,1);
    this.ground_glow_pipeline = new PlanePivotRenderPipeline("reticle_ground_glow","unlit_texture_alpha","reticle_ground_glow",1,1);
    this.nav_glow_pipeline = new NavReticlePipeline("reticle_nav_glow","unlit_texture_alpha","reticle_glow",1,1);

    this.current_pipeline = GROUND_PIPELINE; 
  }

  async build(device: GPUDevice, format: GPUTextureFormat, shader_service: ShaderService,resource_service: ResourceService): Promise<void> 
  {

      await this.ground_pipeline.build(device,format,shader_service,resource_service);
      await this.nav_pipeline.build(device,format,shader_service,resource_service);
      await this.ground_glow_pipeline.build(device,format,shader_service,resource_service);
      await this.nav_glow_pipeline.build(device,format,shader_service,resource_service);
   
      this.transform.set_position(0, 0, 0);
      this.transform.set_rotation(0, 0, 0);

      this.transform.set_scale(0.35, 0.35, 0.35);
      this.transform.update_matrix();
  }

  set_world_position(x: number, y: number, z: number): void 
  {
    this.transform.set_position(x, y, z);
    this.transform.update_matrix();
  }
  set_visible(visible: boolean): void
  {
     this.visible = visible;
  }

  set_ready(ready:boolean):void
  {
     this.ready = ready;
   
  }


  set(kind: "ground" | "nav",x: number, y: number, z: number)
  {
  
    if (kind === "nav")
    {
      this.transform.set_position(x, y, z);
      this.transform.set_rotation(Math.PI * 0.5, 0, 0);
      this.transform.set_scale(0.35, 0.35, 0.35);
      this.current_pipeline = NAV_PIPELINE;
    } 
    else 
    {
      this.transform.set_position(x,y,z );
      this.transform.set_rotation(Math.PI * -0.5, 0, 0);
      this.transform.set_scale(0.5, 0.5, 0.5);
      this.current_pipeline = GROUND_PIPELINE;

    }
    this.transform.update_matrix();
  }

  tick(delta_time: number): void 
  {
  }

  prepare(device: GPUDevice, camera: Camera): void 
  {
    if (!this.visible) return;
    if(this.current_pipeline == GROUND_PIPELINE)
    {
      if(this.ready)
      {
         this.ground_glow_pipeline.prepare(device,camera,this.transform);
      }
      else
      {
       this.ground_pipeline.prepare(device,camera,this.transform);
      }
    }
    else
    {
      if(this.ready)
      {
         this.nav_glow_pipeline.prepare(device,camera,this.transform);
      }
      else
      {
         this.nav_pipeline.prepare(device,camera,this.transform);
      }
    }
  }

  draw(pass: GPURenderPassEncoder): void 
  {
    if (!this.visible) return;
    if(this.current_pipeline == GROUND_PIPELINE)
    {
      if(this.ready)
      {
        this.ground_glow_pipeline.draw(pass);
      }
      else
      {
        this.ground_pipeline.draw(pass);
      }
    }
    else
    {
      if(this.ready)
      {
        this.nav_glow_pipeline.draw(pass);
      }
      else
      {
        this.nav_pipeline.draw(pass);
      }
    }
  }
}